const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/farmso/login.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/farmso/login')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});